export const shouldLoad = (globalState, name) =>
  (globalState[name] && (globalState[name].loadAttempts === 0));



// WEBPACK FOOTER //
// ./src/redux/utils.js